import React, { useEffect, useState } from "react";
import { AddToFavorite } from "../../widgets/AddToFavorite";
import { PersonalChart } from "components/PersonalChart";
import { Row, Col } from "react-bootstrap";
import _ from "lodash";
import { GlobalState } from "contexts/GlobalState";
import { RemoveFavorite } from "components/RemoveFavorite";
import { SearchResultsBody } from "components/programCardComponents/SearchResultsBody";
import { CombineWith } from "components/programCardComponents/CombineWith";
import { OpenUntilAndSignUp } from "components/programCardComponents/OpenUntilAndSignUp";
import { SemestersButtons } from "components/programCardComponents/SemestersButtons";
import { Circle } from "components/programCardComponents/Circle";
import { UniversityComments } from "components/programCardComponents/UniversityComments";
import useCalc from "hooks/useCalc";
import useFocus from "hooks/useFocus";
import { useLazyQuery } from "@apollo/client";
import { GET_PROGRAM_CONFIGURATION } from "schemas/program"

import "./style.scss";

export const SearchResult = ({
  getAllFavorites,
  item,
  labels,
  favorite,
  addToFavoriteLabels,
  id,
  inCalcPage
}) => {

  const [globalCalc, setGlobalCalc] = GlobalState("calc");
  const [globalSearch, setGlobalSearch] = GlobalState("search");
  const [facultyNmae, setFacultyNmae] = useState("");
  const { customHandleClick, customFocusOnTabName } = useFocus(labels);
  const [semester, setSemester] = useState({
    // number: 0,
    // title: item?.field_semester?.[0]?.title,
    // field_this_year_receipt_threshol: item?.field_semester?.[0]?.field_this_year_receipt_threshol,
    // field_this_year_rejection_thresh: item?.field_semester?.[0]?.field_this_year_rejection_thresh,
    // field_end_registration: item?.field_semester?.[0]?.field_end_registration,
  });
  const [dateGlobalSemesters, setDateGlobalSemesters] = useState(null)
  const faculties = labels.faculties.split(',');
  const [getProgramConfiguration, { loading: configurationLoading, data: configurationData }] = useLazyQuery(GET_PROGRAM_CONFIGURATION, {});

  useEffect(() => {
    getProgramConfiguration();
  }, [])

  useEffect(() => {
    if (configurationData?.getProgramConfiguration) {
      let dateOfSemesters = configurationData?.getProgramConfiguration;
      if (dateOfSemesters) {
        setDateGlobalSemesters((prevState) => ({
          ...prevState,
          semesterA: dateOfSemesters?.dates?.semester_a_start_date,
          semesterB: dateOfSemesters?.dates?.semester_b_start_date,
        }));
      }
    }
  }, configurationData)

  useEffect(() => {
    setFacultyNmae(globalSearch.filters.facultyName);
  }, [globalSearch.filters])

  useEffect(() => {
    let defaultSemester = defaultSemesterOpen();
    if (defaultSemester) {
      setSemester((prevState) => ({
        ...prevState, number: defaultSemester.index,
        title: defaultSemesterOpen()?.title,
        field_this_year_receipt_threshol: defaultSemesterOpen()?.field_this_year_receipt_threshol,
        field_this_year_rejection_thresh: defaultSemesterOpen()?.field_this_year_rejection_thresh,
        field_end_registration: defaultSemesterOpen()?.field_end_registration
      }));
    }
  }, [dateGlobalSemesters]);

  const defaultSemesterOpen = () => {
    let defaultSemester = {};
    if (dateGlobalSemesters) {
      if (SemesterbIsDefault() && item?.field_semester[1]) {
        defaultSemester = item?.field_semester[1];
        defaultSemester.index = 1;
      }
      else {
        defaultSemester = item?.field_semester[0] || {}
        defaultSemester.index = 0;
      }
    }
    return defaultSemester;
  }

  const SemesterbIsDefault = () => {
    const semesterA = dateGlobalSemesters?.semesterA?.split('-');
    const TimeStampSemesterA = new Date(semesterA?.[0], semesterA?.[1] - 1, semesterA?.[2])
    const semesterB = dateGlobalSemesters?.semesterB?.split('-');
    const TimeStampSemesterB = new Date(semesterB?.[0], semesterB?.[1] - 1, semesterB?.[2])
    const currentDate = new Date();
    const currentTimeStamp = new Date(currentDate.getFullYear(), (currentDate.getMonth()), currentDate.getDate());
    if (TimeStampSemesterB <= currentTimeStamp) {
      if (TimeStampSemesterB >= TimeStampSemesterA)
        return true;
      else
        if (TimeStampSemesterA > currentTimeStamp)
          return true;
    }
    return false;
  }

  function renderPersonalChart() {
    const suitabilityScore = () => {
      switch (item?.field_faculty_mamta) {
        case faculties[0]:
          return globalCalc?.scoresData?.hatama_meduyakim;
        case faculties[2]:
          return globalCalc?.scoresData?.hatama_nihul;
        case faculties[3]:
          return globalCalc?.scoresData?.hatama_handasa;
        default:
          return globalCalc?.hatamaCalcScore;
      }
    }
    return (
      <Row>
        <PersonalChart
          labels={labels}
          rejectionScore={defaultSemesterOpen()?.field_this_year_rejection_thresh}
          acceptanceScore={defaultSemesterOpen()?.field_this_year_receipt_threshol}
          width={Utils.isMobile() ? "48.1em" : "31.75em"}
          height={Utils.isMobile() ? "25em" : "19.5em"}
          info={true}
          border={"show"}
          calcScore={inCalcPage && suitabilityScore()}
          stats_sentence={true}
        />
      </Row>
    )
  }
  return (
    <div className="search-result" id={id} tabIndex="0">
      <Row className="wrapper-for-border">
        <Col xs={12} md={6} className="details">
          <Row>
            <Circle item={item} />
            <Col sm={10} className="p-0">
              <Row>
                <SearchResultsBody md={10} item={item} labels={labels} parentId={id} />
                <Col md={12} className="semesters-row">
                  <SemestersButtons
                    item={item}
                    semester={semester}
                    setSemester={setSemester}
                    labels={labels}
                  />
                </Col>
                {!Utils.isMobile() && (
                  <CombineWith
                    title={labels?.combine_title}
                    field_reference_combine_programs={
                      item.field_reference_combine_programs
                    }
                    semester={semester}
                    labels={labels}
                  />
                )}
              </Row>
            </Col>
          </Row>
        </Col>

        <Col sm={12} md={6} className="details details-2">
          {!Utils.isMobile() &&
            renderPersonalChart()
          }
          {Utils.isMobile() &&
            defaultSemesterOpen()?.field_this_year_rejection_thresh && defaultSemesterOpen()?.field_this_year_receipt_threshol ?
            renderPersonalChart()
            : ""
          }
          <Row className="add-to-favorite-wrapper">
            {favorite == "" ? (
              <div current-nid={item.nid}>
                <AddToFavorite
                  labels={addToFavoriteLabels}
                  registerFormLabels={labels.RegisterForm.labels}
                  getAllFavorites={getAllFavorites}
                  item={item}
                />
              </div>
            ) : (
              <RemoveFavorite
                getAllFavorites={getAllFavorites}
                labels={labels}
                item={item}
              />
            )}
          </Row>

          < UniversityComments item={item} />
        </Col>
        {Utils.isMobile() && (
          <Col sm={12} className="combine-with-col p-0">
            <CombineWith
              title={labels?.combine_title}
              field_reference_combine_programs={
                item.field_reference_combine_programs
              }
              semester={semester}
              labels={labels}
            />
          </Col>
        )}
        <Col sm={12} md={12} className="open-until-and-signup-col p-0">
          <OpenUntilAndSignUp labels={labels} semester={semester} item={item} parentComponent="SearchResult" />
        </Col>
      </Row>
    </div>
  );
};